// ============ PAGE DEFAULT TEMPLATES — Part 1: Core Pages ============
// home, produits, service, apropos, blog, contact, booking, equipe, partenaires, project, details*

export function homeTemplate(): string {
  return [
    '<!-- Bannières d\'accueil (slider automatique) -->',
    '{{hero_banners}}',
    '',
    '<!-- Hero -->',
    '<section class="hero">',
    '  <div class="hero-overlay"></div>',
    '  <div class="container">',
    '    <div class="hero-content">',
    '      <span class="hero-badge">Bienvenue chez {{site_name}}</span>',
    '      <h1 class="hero-title">{{site_name}}</h1>',
    '      <p class="hero-subtitle">{{site_description}}</p>',
    '      <div class="hero-actions">',
    '        <a href="/produits" class="btn btn-primary">',
    '          <span>Découvrir nos produits</span>',
    '          <i class="ri-arrow-right-line"></i>',
    '        </a>',
    '        <a href="/contact" class="btn btn-outline">Nous contacter</a>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</section>',
    '',
    '<!-- Featured Products -->',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Boutique</span>',
    '      <h2>Nos produits phares</h2>',
    '      <p>Découvrez notre sélection de produits de qualité</p>',
    '    </div>',
    '    {{featured_products limit="8"}}',
    '    <div class="section-footer">',
    '      <a href="/produits" class="btn btn-outline">Voir toute la boutique <i class="ri-arrow-right-line"></i></a>',
    '    </div>',
    '  </div>',
    '</section>',
    '',
    '<!-- Services -->',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Expertise</span>',
    '      <h2>Nos services</h2>',
    '      <p>Des solutions sur mesure pour répondre à vos besoins</p>',
    '    </div>',
    '    {{services}}',
    '  </div>',
    '</section>',
    '',
    '<!-- About Summary -->',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="about-preview">',
    '      <div class="about-preview-content">',
    '        <span class="section-tag">À propos</span>',
    '        <h2>Qui sommes-nous ?</h2>',
    '        {{site_about}}',
    '        <a href="/apropos" class="btn btn-outline">En savoir plus <i class="ri-arrow-right-line"></i></a>',
    '      </div>',
    '      <div class="about-preview-image">',
    '        {{site_logo}}',
    '      </div>',
    '    </div>',
    '  </div>',
    '</section>',
    '',
    '<!-- Testimonials -->',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Avis clients</span>',
    '      <h2>Ce que nos clients disent</h2>',
    '      <p>La satisfaction de nos clients est notre priorité</p>',
    '    </div>',
    '    {{testimonials}}',
    '  </div>',
    '</section>',
    '',
    '<!-- Partners -->',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Partenaires</span>',
    '      <h2>Ils nous font confiance</h2>',
    '      <p>Des collaborations solides et durables</p>',
    '    </div>',
    '    {{partners}}',
    '  </div>',
    '</section>',
    '',
    '<!-- Stats -->',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    {{stats}}',
    '  </div>',
    '</section>',
    '',
    '<!-- Contact -->',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Contact</span>',
    '      <h2>Une question ? Un projet ?</h2>',
    '      <p>Nous sommes à votre écoute</p>',
    '    </div>',
    '    <div class="contact-layout">',
    '      <div class="contact-form-wrapper">',
    '        {{contact_form}}',
    '      </div>',
    '      <div class="contact-info-card">',
    '        <div class="contact-info-item">',
    '          <i class="ri-phone-line"></i>',
    '          <div><span class="contact-info-label">Téléphone</span><a href="tel:{{site_phone}}">{{site_phone}}</a></div>',
    '        </div>',
    '        <div class="contact-info-item">',
    '          <i class="ri-mail-line"></i>',
    '          <div><span class="contact-info-label">Email</span><a href="mailto:{{site_email}}">{{site_email}}</a></div>',
    '        </div>',
    '        <div class="contact-info-item">',
    '          <i class="ri-map-pin-line"></i>',
    '          <div><span class="contact-info-label">Adresse</span><span>{{site_address}}</span></div>',
    '        </div>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function produitsTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Boutique</span>',
    '    <h1>{{site_name}} — Nos produits</h1>',
    '    <p>Parcourez notre catalogue complet</p>',
    '  </div>',
    '</section>',
    '<!-- Categories -->',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="section-header"><h2>Catégories</h2></div>',
    '    {{marketplace_categories}}',
    '  </div>',
    '</section>',
    '<!-- All Products -->',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="section-header"><h2>Tous les produits</h2></div>',
    '    {{products}}',
    '  </div>',
    '</section>',
    '<!-- Featured -->',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="section-header"><h2>Nos recommandations</h2></div>',
    '    {{featured_products limit="4"}}',
    '    <div class="section-footer">',
    '      <a href="/contact" class="btn btn-outline">Une question ? Contactez-nous <i class="ri-arrow-right-line"></i></a>',
    '    </div>',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function serviceTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Expertise</span>',
    '    <h1>{{site_name}} — Nos services</h1>',
    '    <p>Des solutions professionnelles adaptées à vos besoins</p>',
    '  </div>',
    '</section>',
    '<section class="section"><div class="container">{{services}}</div></section>',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="section-header"><h2>{{site_name}} en chiffres</h2></div>',
    '    {{stats}}',
    '  </div>',
    '</section>',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="section-header"><h2>Témoignages clients</h2></div>',
    '    {{testimonials}}',
    '  </div>',
    '</section>',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="cta-block">',
    '      <h2>Prêt à démarrer votre projet ?</h2>',
    '      <p>Contactez-nous pour discuter de vos besoins</p>',
    '      <div class="cta-actions">',
    '        <a href="/contact" class="btn btn-primary"><span>Demander un devis</span><i class="ri-arrow-right-line"></i></a>',
    '        <span class="cta-phone">ou appelez-nous au <a href="tel:{{site_phone}}">{{site_phone}}</a></span>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function aproposTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Notre histoire</span>',
    '    <h1>À propos de {{site_name}}</h1>',
    '    <p>Découvrez qui nous sommes et ce qui nous anime</p>',
    '  </div>',
    '</section>',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="about-layout">',
    '      <div class="about-content">{{site_about}}</div>',
    '      <div class="about-image">{{site_logo}}</div>',
    '    </div>',
    '  </div>',
    '</section>',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Équipe</span>',
    '      <h2>Notre équipe</h2>',
    '      <p>Des passionnés à votre service</p>',
    '    </div>',
    '    {{team}}',
    '  </div>',
    '</section>',
    '<section class="section"><div class="container">{{stats}}</div></section>',
    '<!-- Portfolio -->',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Réalisations</span>',
    '      <h2>Nos projets</h2>',
    '      <p>Quelques-unes de nos réalisations récentes</p>',
    '    </div>',
    '    {{portfolio}}',
    '  </div>',
    '</section>',
    '<!-- Partners -->',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="section-header">',
    '      <span class="section-tag">Partenaires</span>',
    '      <h2>Ils nous font confiance</h2>',
    '    </div>',
    '    {{partners}}',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function blogTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Actualités</span>',
    '    <h1>{{site_name}} — Blog</h1>',
    '    <p>Conseils, actualités et inspirations</p>',
    '  </div>',
    '</section>',
    '<section class="section"><div class="container"><div class="blog-layout"><div class="blog-main">{{blog_posts}}</div></div></div></section>',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="newsletter-block">',
    '      <div class="newsletter-content">',
    '        <i class="ri-mail-send-line newsletter-icon"></i>',
    '        <h3>Restez informé</h3>',
    '        <p>Recevez nos derniers articles et actualités directement dans votre boîte mail.</p>',
    '      </div>',
    '      {{contact_form}}',
    '    </div>',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function contactTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Contact</span>',
    '    <h1>Contactez-nous</h1>',
    '    <p>Nous sommes à votre écoute, n\'hésitez pas à nous écrire</p>',
    '  </div>',
    '</section>',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="contact-layout">',
    '      <div class="contact-form-wrapper">',
    '        <h2 class="contact-form-title">Envoyez-nous un message</h2>',
    '        {{contact_form}}',
    '      </div>',
    '      <div class="contact-info-card">',
    '        <div class="contact-info-item"><i class="ri-phone-line"></i><div><span class="contact-info-label">Téléphone</span><a href="tel:{{site_phone}}">{{site_phone}}</a></div></div>',
    '        <div class="contact-info-item"><i class="ri-mail-line"></i><div><span class="contact-info-label">Email</span><a href="mailto:{{site_email}}">{{site_email}}</a></div></div>',
    '        <div class="contact-info-item"><i class="ri-map-pin-line"></i><div><span class="contact-info-label">Adresse</span><span>{{site_address}}</span></div></div>',
    '        <div class="contact-info-item"><i class="ri-time-line"></i><div><span class="contact-info-label">Horaires</span><span>Lun—Ven : 9h—18h</span></div></div>',
    '        <div class="contact-social">',
    '          <span class="contact-info-label">Suivez-nous</span>',
    '          <div class="contact-social-icons">',
    '            <a href="#" class="social-link" aria-label="Facebook" rel="nofollow noopener" target="_blank"><i class="ri-facebook-fill"></i></a>',
    '            <a href="#" class="social-link" aria-label="Instagram" rel="nofollow noopener" target="_blank"><i class="ri-instagram-line"></i></a>',
    '            <a href="#" class="social-link" aria-label="Twitter / X" rel="nofollow noopener" target="_blank"><i class="ri-twitter-x-line"></i></a>',
    '            <a href="#" class="social-link" aria-label="LinkedIn" rel="nofollow noopener" target="_blank"><i class="ri-linkedin-fill"></i></a>',
    '          </div>',
    '        </div>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function bookingTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Réservation</span>',
    '    <h1>Réservez en ligne</h1>',
    '    <p>Choisissez votre créneau et réservez en quelques clics</p>',
    '  </div>',
    '</section>',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="booking-layout">',
    '      <div class="booking-form-wrapper">{{booking_form}}</div>',
    '      <div class="booking-info">',
    '        <h3>Informations</h3>',
    '        <div class="booking-info-list">',
    '          <div class="booking-info-item"><i class="ri-time-line"></i><div><strong>Horaires</strong><p>Lun—Ven : 9h—18h</p></div></div>',
    '          <div class="booking-info-item"><i class="ri-phone-line"></i><div><strong>Besoin d\'aide ?</strong><a href="tel:{{site_phone}}">{{site_phone}}</a></div></div>',
    '          <div class="booking-info-item"><i class="ri-mail-line"></i><div><strong>Par email</strong><a href="mailto:{{site_email}}">{{site_email}}</a></div></div>',
    '        </div>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</section>',
    '<section class="section section-alt"><div class="container"><div class="section-header"><h2>Nos prestations</h2></div>{{services}}</div></section>',
  ].join('\n');
}

export function bookingsuccessTemplate(): string {
  return [
    '<section class="section"><div class="container"><div class="success-block"><div class="success-icon"><i class="ri-check-double-line"></i></div><h1>Réservation confirmée !</h1><p>Merci pour votre réservation. Vous recevrez un email de confirmation dans quelques instants.</p><div class="success-actions"><a href="/" class="btn btn-primary">Retour à l\'accueil</a><a href="/contact" class="btn btn-outline">Nous contacter</a></div></div></div></section>',
  ].join('\n');
}

export function equipeTemplate(): string {
  return [
    '<section class="page-header"><div class="container"><span class="page-tag">Équipe</span><h1>Notre équipe</h1><p>Des professionnels passionnés à votre service</p></div></section>',
    '<section class="section"><div class="container">{{team}}</div></section>',
    '<section class="section section-alt"><div class="container">{{stats}}</div></section>',
    '<section class="section"><div class="container"><div class="cta-block"><h2>Rejoignez notre équipe</h2><p>Nous recrutons des talents passionnés</p><a href="/contact" class="btn btn-primary"><span>Nous contacter</span><i class="ri-arrow-right-line"></i></a></div></div></section>',
  ].join('\n');
}

export function partenairesTemplate(): string {
  return [
    '<section class="page-header"><div class="container"><span class="page-tag">Partenaires</span><h1>Nos partenaires</h1><p>Des collaborations de confiance</p></div></section>',
    '<section class="section"><div class="container">{{partners}}</div></section>',
    '<section class="section section-alt"><div class="container"><div class="section-header"><h2>Ce qu\'ils disent de nous</h2></div>{{testimonials}}</div></section>',
    '<section class="section"><div class="container"><div class="cta-block"><h2>Devenir partenaire</h2><p>Vous souhaitez collaborer avec {{site_name}} ?</p><a href="/contact" class="btn btn-primary"><span>Contactez-nous</span><i class="ri-arrow-right-line"></i></a></div></div></section>',
  ].join('\n');
}

export function projectTemplate(): string {
  return [
    '<section class="page-header"><div class="container"><span class="page-tag">Portfolio</span><h1>Nos projets</h1><p>Découvrez nos réalisations récentes</p></div></section>',
    '<section class="section"><div class="container">{{portfolio}}</div></section>',
    '<section class="section section-alt"><div class="container">{{stats}}</div></section>',
    '<section class="section"><div class="container"><div class="section-header"><h2>Ce que nos clients disent</h2></div>{{testimonials}}</div></section>',
  ].join('\n');
}

export function detailsproduitTemplate(): string {
  return [
    '<section class="section"><div class="container"><a href="/produits" class="back-link"><i class="ri-arrow-left-line"></i><span>Retour à la boutique</span></a><div class="product-detail">{{products limit="1"}}</div></div></section>',
    '<section class="section section-alt"><div class="container"><div class="section-header"><h3>Vous pourriez aussi aimer</h3></div>{{featured_products limit="4"}}</div></section>',
  ].join('\n');
}

export function detailsserviceTemplate(): string {
  return [
    '<section class="section"><div class="container"><a href="/service" class="back-link"><i class="ri-arrow-left-line"></i><span>Retour aux services</span></a><div class="service-detail">{{services limit="1"}}</div></div></section>',
    '<section class="section section-alt"><div class="container"><div class="section-header"><h3>Autres services</h3></div>{{services}}</div></section>',
  ].join('\n');
}

export function detailsblogTemplate(): string {
  return [
    '<section class="section"><div class="container"><a href="/blog" class="back-link"><i class="ri-arrow-left-line"></i><span>Retour au blog</span></a><article class="blog-article">{{blog_posts limit="1"}}</article></div></section>',
    '<section class="section section-alt"><div class="container"><div class="section-header"><h3>Articles similaires</h3></div>{{blog_posts limit="3"}}</div></section>',
  ].join('\n');
}

export function faqTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Aide</span>',
    '    <h1>Foire Aux Questions</h1>',
    '    <p>Trouvez rapidement des réponses à vos questions les plus fréquentes</p>',
    '  </div>',
    '</section>',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="faq-wrapper">',
    '      <div class="faq-search">',
    '        <div class="faq-search-input">',
    '          <i class="ri-search-line faq-search-icon"></i>',
    '          <input type="text" placeholder="Rechercher une question..." class="faq-search-field">',
    '        </div>',
    '      </div>',
    '      {{faq}}',
    '    </div>',
    '  </div>',
    '</section>',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="cta-block">',
    '      <h2>Vous n\'avez pas trouvé votre réponse ?</h2>',
    '      <p>Notre équipe est là pour vous aider</p>',
    '      <div class="cta-actions">',
    '        <a href="/contact" class="btn btn-primary"><span>Nous contacter</span><i class="ri-arrow-right-line"></i></a>',
    '        <span class="cta-phone">ou appelez-nous au <a href="tel:{{site_phone}}">{{site_phone}}</a></span>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function galleryTemplate(): string {
  return [
    '<section class="page-header">',
    '  <div class="container">',
    '    <span class="page-tag">Galerie</span>',
    '    <h1>Notre galerie</h1>',
    '    <p>Explorez nos plus belles réalisations en images</p>',
    '  </div>',
    '</section>',
    '<section class="section">',
    '  <div class="container">',
    '    <div class="gallery-filters">',
    '      <button class="gallery-filter gallery-filter-active">Tout</button>',
    '      <button class="gallery-filter">Projets</button>',
    '      <button class="gallery-filter">Événements</button>',
    '      <button class="gallery-filter">Produits</button>',
    '    </div>',
    '    {{gallery}}',
    '  </div>',
    '</section>',
    '<section class="section section-alt">',
    '  <div class="container">',
    '    <div class="cta-block">',
    '      <h2>Vous avez un projet en tête ?</h2>',
    '      <p>Discutons de vos idées et voyons comment nous pouvons les réaliser ensemble</p>',
    '      <a href="/contact" class="btn btn-primary"><span>Démarrer un projet</span><i class="ri-arrow-right-line"></i></a>',
    '    </div>',
    '  </div>',
    '</section>',
  ].join('\n');
}

export function detailsproduitsTemplate(): string {
  return [
    '<section class="page-header"><div class="container"><h1>Comparaison produits</h1></div></section>',
    '<section class="section"><div class="container">{{products}}</div></section>',
  ].join('\n');
}